<app-page-meta pageTitle="finzy - Portfolio Details"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
    <div class="row">
        <app-investormenu></app-investormenu>

        <div class="col-xs-12 col-md-10 col-lg-11 main-content">
            <div *ngIf="!shouldShowLoader">
                <p class="small-heading text-center mt-5" *ngIf="!hasMadeInvestments()">There are no loans found for
                    this portfolio yet</p>

                <div class="row finzy-rowtop">
                    <div class="col-md-4 col-md-offset-4 col-xs-12 text-center">
                        <app-doughnut [dataSet]="chartData" [centerText]="'ROI: ' + roi + '%'"
                                      *ngIf="roi && chartData.length > 0"></app-doughnut>
                    </div>
                </div>

                <div class="row finzy-row5">

                    <p class="finzy-txt-ps72">{{portfolio_name}}</p>
                    <p class="finzy-txt-ps73" *ngIf="isConsolidatedPortfolioType(portfolio_type)">[{{portfolio_type}}]</p>
                    <p class="finzy-txt-ps73" *ngIf="!isConsolidatedPortfolioType(portfolio_type)">[{{portfolio_type}}] - {{portfolio_date}}</p>

                    <div class="row finzy-row32">
                        <p class="finzy-txt-ps7">INVESTMENT AMOUNT</p>
                        <p class="finzy-p8">
                            <app-indian-currency-formatter [amount]="portfolio_amt"
                                                           [minimumFractionDigits]="0">
                            </app-indian-currency-formatter>
                        <p class="finzy-p9" *ngIf="hasMadeInvestments()"> ROI {{roi | number : '1.2-2'}}</p>
                        <hr class="hr-finzy">
                    </div>

                    <app-portfolio-detail-preferences [portfolioId]="portfolioId" [portfolioType]="portfolio_type"
                                                      [portfolioCreationDate]="portfolio_date"
                                                      [portfolioRemainingAmount]="remainingAmount">
                    </app-portfolio-detail-preferences>

                    <div class="row finzy-row10" *ngIf="hasMadeInvestments()">
                        <mat-table #table [dataSource]="dataSource" matSort>

                            <ng-container matColumnDef="loan">
                                <mat-header-cell *matHeaderCellDef> Loan</mat-header-cell>
                                <mat-cell *matCellDef="let element"><a class="loan_id"
                                                                       (click)="goToLoan(element._id,element.loan_sanction_status)">Loan
                                    Details</a></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <mat-header-cell *matHeaderCellDef> Loan Status</mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{element.status}}</mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="rating">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Rating</mat-header-cell>
                                <mat-cell *matCellDef="let element"><span
                                        class="{{element.rating}}">{{element.rating}}</span></mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="fund_allocation">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Amount Invested</mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <app-indian-currency-formatter
                                            [amount]="element.fund_allocation"
                                            [minimumFractionDigits]="0">
                                    </app-indian-currency-formatter>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="borrower">
                                <mat-header-cell *matHeaderCellDef> Borrower</mat-header-cell>
                                <mat-cell *matCellDef="let element"><a class="loan_id"
                                                                       (click)="viewLoanDetails(element.loan_data, element.fund_allocation)">Borrower
                                    Details</a></mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>

                        <mat-paginator #paginator [length]="5"
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 20]">
                        </mat-paginator>
                    </div>
                </div>

                <div class="row finzy-row4 mt-4">
                    <p class="finzy-p6">If you need assistance you can find help here <a target="_blank"
                                                                                         [routerLink]="['/faq']"
                                                                                         class="finzy-col">FAQs</a>. You
                        could even call us on 9341 300 300. We are always happy to help!</p>
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center align-items-center"
                 style="height: 80vh;"
                 *ngIf="shouldShowLoader">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
